import React from 'react';

import './index.sass';

const MergedCategories = ({ classes, mainCategory, secondaryCategories }) => {

  const secondaryCategoriesPresent = !!(secondaryCategories && secondaryCategories.length);

  return (
    <div className={`merged-categories ${classes || ''}`}>
      <div className="merged-categories__category">
        { mainCategory.name }
        <div className="merged-categories__plus-count"/>
      </div>

      { secondaryCategoriesPresent &&
        secondaryCategories.map(category =>
          <div className="merged-categories__category" key={category.id}>
            <span>&nbsp;· { category.name }</span>
            <div className="merged-categories__plus-count"/>
          </div>
        )
      }
    </div>
  )
}

export default MergedCategories;
